/**
 * Copy text on this HTTP page. `navigator.clipboard.writeText` is commonly
 * blocked off HTTPS, so fall back to a hidden textarea + `execCommand`.
 * Rejects when neither path worked so callers can offer a manual ⌘C.
 */
export function copyToClipboard(text: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const fallback = () => {
      const el = document.createElement("textarea");
      el.value = text;
      el.setAttribute("readonly", "");
      el.style.position = "fixed";
      el.style.top = "0";
      el.style.left = "0";
      el.style.width = "2px";
      el.style.height = "2px";
      el.style.opacity = "0.01";
      el.style.padding = "0";
      el.style.border = "none";
      document.body.appendChild(el);
      el.focus();
      el.select();
      el.setSelectionRange(0, el.value.length);
      let ok = false;
      try {
        ok = document.execCommand("copy");
      } finally {
        document.body.removeChild(el);
      }
      if (ok) resolve();
      else reject(new Error("copy failed"));
    };
    const clip = typeof navigator !== "undefined" ? navigator.clipboard : undefined;
    if (clip && typeof clip.writeText === "function" && window.isSecureContext) {
      clip.writeText(text).then(resolve).catch(fallback);
      return;
    }
    fallback();
  });
}
